import { EmployeeMatchingFiltersModel } from '../models';

export const DEFAULT_MATCHING_FILTERS_CONFIG: Pick<
  EmployeeMatchingFiltersModel,
  'areaRadius' | 'freeText'
> = {
  areaRadius: 15000,
  freeText: null,
};
